export default {
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  contentModule: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    width: '100%',
    position: 'relative',
    boxSizing: 'border-box',
  },
  contentModuleRow: {
    display: 'flex',
  },
  contentModuleCell: {
    font: "500 15px 'Roboto', sans-serif",
    color: "#666666",
    display: 'table-cell',
    width: '50%',
    '&$short': {
      width: '35%'
    },
    '&$large': {
      width: '65%'
    },
  },
  contentModuleCellPrice: {
    font: "500 15px 'Roboto', sans-serif",
    display: 'block',
    textAlign: 'right',
  },
  taxes:{
    font: "400 13px 'Roboto', sans-serif",
  },
}